// ============================================
// 认证 API
// ============================================
// 参考 RuoYi-UI 认证流程重构

import request from '../utils/request'

// 登录（只返回 Token）
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 登出
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

// 获取当前用户信息、角色、权限
export function getInfo() {
  return request({
    url: '/auth/getInfo',
    method: 'get'
  })
}

// 获取当前用户路由数据
export function getRouters() {
  return request({
    url: '/auth/getRouters',
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/auth/password',
    method: 'put',
    data
  })
}
